import mockReport from './../../../data/mockReport.json';

const mockReportAPI = (mockAdapter: any) => {
  mockAdapter.onGet('/report').reply(200, mockReport.report);
  mockAdapter.onGet('/report/topics').reply(200, mockReport.report_topic);
  mockAdapter.onGet('/report/weekly_heatmap').reply(200, mockReport.report_weekly_heatmap);
};

export default mockReportAPI;
